import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Project, SitePage } from '../../project-data';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html',
})
export class SiteFooterComponent {
  @Input({ required: true }) projects: Project[] = [];
  @Output() readonly homeSectionSelected = new EventEmitter<string>();
  @Output() readonly inquiryRequested = new EventEmitter<string>();
  @Output() readonly pageSelected = new EventEmitter<SitePage>();
}
